import { parse as parseConfig } from "../../services/helpers/config";
import { updateScroll } from "../../services/live";
import ModalBlocked from "../modal/modal-blocked";
import Toast from "../modal/toast";

export default class Banner {
    static colors = {
        white: "rgb(255, 255, 255)",
        red: "rgb(255, 245, 247)",
        green: "rgb(244, 254, 247)",
        yellow: "rgb(253, 252, 241)",
        blue: "rgb(245, 252, 255)"
    }

    static popup = null

    static initPopup() {
        const element = document.getElementById("lead");

        if (!element) {
            return;
        }

        const form = element.querySelector("form");
        const info = element.querySelector("[data-info-text]");
        const popup = ModalBlocked.get(element);

        form.addEventListener("submit", (event) => {
            event.preventDefault();

            const body = new FormData(form);

            if (body.get("email") === ""
                && body.get("telegram") === ""
                && body.get("phoneNumber") === "") {
                info.textContent = "Пожалуйста, заполните одно из полей: почта, телеграм, номер телефона. Нам же нужно как-то с Вами связаться";
                info.classList.add("color_error");

                return;
            }

            body.append("bannerId", form.dataset.bid);

            fetch(form.action, {
                method: "POST",
                body: body
            })
            .then(() => {
                popup.close();
                Toast.open(form.dataset.outro);
            });
        });

        return { popup, form, element };
    }

    constructor(container) {
        if (!container) {
            return null;
        }

        this.showTime = null;
        this.observer = null;
        this.bannerData = null;
        this.container = container;
        this.config = parseConfig(this.container.dataset.configItem || "");
        this.banner = this.container.querySelector(".info-block");
        this.form = this.container.querySelector("form");
        this.nodes = this.initNodes();

        if (!Banner.popup) {
            Banner.popup = Banner.initPopup();
        }

        if (this.loading) {
            this.request();
        }
    }

    get loading() {
        return this.banner.classList.contains("loading");
    }

    set loading(value) {
        this.banner.classList.toggle("loading", value);
    }

    set data(value) {
        this.bannerData = Object.assign({
            "area-placeholder": "Пожелания, предложения"
        }, value);
        this.showTime = (new Date).getTime();

        if (value.hasLead) {
            this.banner.href = "javascript:void 0;";
            this.banner.target = "";
        }
        else {
            this.banner.href = value.buttonUrl;
        }
        this.banner.style.background = Banner.colors[value.background];
        this.nodes.header.textContent = value.title;
        this.nodes.text.textContent = value.text;
        this.nodes.button.textContent = value.button;
        this.nodes.img.src = window.mediaDomainUrl + "/" + value.image;
    }

    initNodes() {
        return {
            header: this.banner.querySelector(".info-block__header"),
            text: this.banner.querySelector(".info-block__text"),
            button: this.banner.querySelector(".info-block__btn"),
            img: this.banner.querySelector(".info-block__figure img"),
            close: this.banner.querySelector(".info-block__close [data-close-btn]")
        };
    }

    initListener() {
        if ("IntersectionObserver" in window) {
            const options = {
                root: null,
                rootMargin: "0px",
                threshold: 1
            };
            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.observer.unobserve(entry.target);
                        this.view();
                    }
                });
            };
            this.observer = new IntersectionObserver(callback, options);
            this.observer.observe(this.banner);
        }

        this.banner.addEventListener("click", () => this.click());

        if (this.nodes.close) {
            this.nodes.close.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.close();
            }, true);
        }

        if (this.bannerData.hasLead) {
            this.banner.addEventListener("click", () => this.openLead());
        }

        if (this.config.position === "header") {
            updateScroll();
        }
    }

    remove() {
        let removable = this.container.closest("[data-remove-with-banner]");

        this.container.parentNode.removeChild(this.container);
        
        if (removable) {
            removable.parentNode.removeChild(removable);
        }
    }

    close() {
        if (this.config.position === "header") {
            document.body.classList.remove("has-header-info");
            document.querySelector("header.sheet__header").classList.remove("sheet-header-info");
            document.body.dispatchEvent(new CustomEvent("sidebar.update"));
        }

        this.remove();

        if (this.config.position === "header") {
            updateScroll();
        }
    }

    request() {
        if (!this.form) {
            return null;
        }

        const callback = (json) => {
            this.loading = false;

            if (json.banner && json.banner.positions.includes(this.config.position)) {
                this.data = json.banner;
                this.initListener();
            }
            else {
                this.close();
            }
        };

        window.setTimeout(() => {
            fetch(this.form.action, {
                method: this.form.method,
                body: new FormData(this.form)
            })
            .then(response => response.json())
            .then(json => {
                if (json.banner && json.banner.position) {
                    json.banner.positions = json.banner.position.split(",");
                }
                else if (json.banner) {
                    json.banner.positions = [];
                }

                callback(json);
            });
        }, this.config.timeout || 0);
    }

    view() {
        const body = new FormData();

        body.append("token", this.config.viewToken);
        body.append("position", this.config.position);

        if ("__infoSlug" in window) {
            body.append("slug", window.__infoSlug);
        }

        fetch(`/post-info/${ this.bannerData.id }/view`, {
            method: "POST",
            body: body
        })
    }

    click() {
        const body = new FormData();
        const time = (new Date).getTime();
        const timeSpent = (time - this.showTime);

        body.append("token", this.config.clickToken);
        body.append("timeToClick", timeSpent);
        body.append("position", this.config.position);

        if ("__infoSlug" in window) {
            body.append("slug", window.__infoSlug);
        }

        fetch(`/post-info/${ this.bannerData.id }/click`, {
            method: "POST",
            body: body
        })
    }

    openLead() {
        for (const key of [ "intro", "area-placeholder" ]) {
            if (key in this.bannerData) {
                Banner.popup.element.querySelectorAll(`[data-key="${ key }"]`)
                    .forEach(item => item.textContent = this.bannerData[key]);
            }
        }

        Banner.popup.form.dataset.bid = this.bannerData.id;
        Banner.popup.form.dataset.outro = this.bannerData.outro;
        Banner.popup.popup.open();
    }
}
